
import Vue from "vue"

  export default Vue.extend({
    props: {
        currentPage: Number,
        lastPage: Number,
        contentRange: String
    },
    methods: {
        navigate(page: number) {
            if (page < 1) {
                page = 1
            } else if (page > this.lastPage) {
                page = this.lastPage
            }
            this.$emit("changePage", page)
        }
    }
  })
